import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const Caption = (props) => (
  <span {...props} className={cn(styles.caption, props.className)} />
);

Caption.propTypes = {
  className: PropTypes.string,
};

export default Caption;
